"use client";

import { Slot, Slottable } from "@radix-ui/react-slot";
import { type VariantProps } from "class-variance-authority";
import { forwardRef } from "react";

import { cn } from "../lib/utils";
import { buttonVariants } from "./button";
import { Icon } from "./icon";

interface PillProps
  extends
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    Pick<VariantProps<typeof buttonVariants>, "size"> {
  asChild?: boolean;
}

const Pill = forwardRef<HTMLButtonElement, PillProps>(
  (
    { asChild, className, children, size = "xs", type = "button", ...props },
    ref,
  ) => {
    const Comp = asChild ? Slot : "button";

    return (
      <Comp
        className={cn(
          buttonVariants({ variant: "secondary", size }),
          "group min-w-min !rounded-full focus-visible:ring-0",
          className,
        )}
        {...{
          ...props,
        }}
        ref={ref}
        type={type}
      >
        <Slottable>{children}</Slottable>

        <Icon
          className="block rounded-full group-hover:hidden group-focus-visible:ring-1 group-focus-visible:ring-ring group-focus-visible:ring-offset-1"
          icon="x"
        />
        <Icon
          className="hidden rounded-full group-hover:block group-focus-visible:ring-1 group-focus-visible:ring-ring group-focus-visible:ring-offset-1"
          icon="x"
          weight="bold"
        />
      </Comp>
    );
  },
);
Pill.displayName = "Pill";

export { Pill, type PillProps };
